<template>
  <v-app>
    <router-view />

    <v-snackbar
      :timeout="$store.state.snackbar.timeout"
      top
      right
      :color="$store.state.snackbar.color"
      v-model="$store.state.snackbar.show"
    >
      <strong>{{ $store.state.snackbar.message }}</strong>
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          dark
          text
          v-bind="attrs"
          id="clear_notification"
          @click="hideSnackbar"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  data: () => ({}),

  computed: {},
  methods: {
    hideSnackbar() {
      this.$store.commit("hideSnackbar");
    },
  },
  async created() {},
};
</script>
<style>
.v-card__title {
  padding: 6px;
}
.v-data-table {
  background-color: var(--v-secondary-base) !important;
}
.v-application--is-ltr .v-data-table--fixed-header .v-data-footer {
  margin-right: 0 !important;
}

.v-application a {
  color: #4f4584 !important;
}

.v-card__title {
  height: 50px;
  display: flex;
  align-content: center;
  font-size: 16px !important;
  font-weight: 400 !important;
}
.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
.ql-editor {
  min-height: 100px !important;
  font-size: 16px !important;
  overflow-y: scroll;
  height: 150px !important;
}

.v-label {
  font-size: 15px !important;
}

.v-data-table.row-height-50 td {
  height: 44px !important;
}
.v-data-table td {
  white-space: nowrap;
}

.v-data-table th {
  white-space: nowrap;
}
</style>
